import React from "react"
import { Stack } from "@mui/material"

const styles = {
	"& h4": {
		marginBottom: "5px !important"
	}
}

export default function ListContainer({ children, ...props }) {
	return (
		<Stack component="ul" sx={styles} {...props}>
			{children}
		</Stack>
	)
}
